import { CARE_CLICKS_BANNER } from "../../data/siteData";
import "./CareClicks.css";

function CareClicks() {
  return (
    <section className="care-clicks" style={{ backgroundImage: `url(${CARE_CLICKS_BANNER.bgImage})` }}>
      <h2 className="care-clicks__heading">{CARE_CLICKS_BANNER.heading}</h2>
    </section>
  );
}

export default CareClicks;
